<template>
  <div class="m-layout">
    <!-- head部分 -->
    <m-head></m-head>
    <!-- 主体内容 -->
    <div class="content">
      <slot></slot>
    </div>
    <!-- footer部分 -->
    <m-footer v-if="!isContact"></m-footer>
  </div>
</template>

<script>
import mHead from "../../components/mobile/Head";
import mFooter from "../../components/mobile/Footer";
export default {
  components: {
    mHead,
    mFooter
  },
  computed: {
    isContact() {
      return this.$route.path === "/contact";
    }
  }
};
</script>

<style lang="scss" scoped>
.m-layout {
  .content {
    min-height: calc(100vh - 398px);
    background: $blue_bg;
  }
}
</style>

